"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECTIONS = void 0;
var SECTIONS = {
    GENERAL: 'general',
    PROFILES: 'profiles',
    PLAYER: 'player',
    INTERFACE: 'interface',
    STREAMING: 'streaming',
    SHORTCUTS: 'shortcuts',
};
exports.SECTIONS = SECTIONS;
